import { MultiPolygon, Polygon } from 'geojson';

import { Logger } from '@/lib/logs/logger';

export const transformPolygonToMultiPolygon = (polygon: Polygon | null | undefined): MultiPolygon => {
  if (!polygon) {
    Logger.error('Received null or undefined polygon, returning empty MultiPolygon');
    return {
      type: 'MultiPolygon',
      coordinates: [],
    };
  }

  return {
    type: 'MultiPolygon',
    coordinates: [polygon.coordinates],
  };
};

// TODO: MVP-9664 - remove transformMultiPolygonToPolygon when BE drops required polygon for plot POST request
export const transformMultiPolygonToPolygon = (multiPolygon: MultiPolygon | null | undefined): Polygon => {
  if (!multiPolygon) {
    Logger.error('Received null or undefined multiPolygon, returning null');
    return {
      type: 'Polygon',
      coordinates: [],
    };
  }

  if (multiPolygon.coordinates.length !== 1) {
    Logger.warn('Received MultiPolygon with more than one polygon, returning empty Polygon');
    return {
      type: 'Polygon',
      coordinates: [],
    };
  }

  return {
    type: 'Polygon',
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    coordinates: multiPolygon.coordinates[0]!,
  };
};
